'use client';

import { HEADER_DRAWER_ID } from './header-config';
import { useHeaderDrawer } from './header-drawer-store';
import { MenuIcon } from './header-icons';

export function HeaderMenuButton({ label }: { label: string }) {
  const isOpen = useHeaderDrawer(state => state.isOpen);
  const open = useHeaderDrawer(state => state.open);

  return (
    <button
      type="button"
      aria-label={label}
      aria-expanded={isOpen}
      aria-controls={HEADER_DRAWER_ID}
      onClick={open}
      className="flex cursor-pointer bg-transparent p-1.5 text-[#14181c] min-[901px]:hidden"
    >
      <MenuIcon />
    </button>
  );
}
